var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPositive = function SvgPositive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212B36",
    d: "M12.667 7.333h-4v-4a.667.667 0 0 0-1.334 0v4h-4a.667.667 0 0 0 0 1.334h4v4a.667.667 0 1 0 1.334 0v-4h4a.667.667 0 1 0 0-1.334Z"
  })));
};
export default SvgPositive;